import React from 'react'

import { Table } from 'antd'

import { formatMoney } from 'common/moneyFormatter'

import './CompanyTotalBalance.less'

interface CompanyTotalBalanceProps {
  translate: (key: string) => string
  allowanceYtd: number
  reimbursementsYtd: number
  availableAllowance: number
}

const CompanyTotalBalance: React.FC<CompanyTotalBalanceProps> = (props) => {
  return (
    <Table.Summary fixed>
      <Table.Summary.Row className="company-total-balance">
        <Table.Summary.Cell className="company-total-balance-cell" index={0}></Table.Summary.Cell>
        <Table.Summary.Cell index={1} className="company-total-balance-cell text-light-bold">
          {props.translate('admin-dashboard.reimbursements.reimbursements-balances.company-totals-label')}
        </Table.Summary.Cell>
        <Table.Summary.Cell index={2} className="company-total-balance-cell text-light-bold">
          <div className="float-right">{formatMoney(props.allowanceYtd)}</div>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={3} className="company-total-balance-cell text-light-bold">
          <div className="float-right">{formatMoney(props.reimbursementsYtd)}</div>
        </Table.Summary.Cell>
        <Table.Summary.Cell index={4} className="company-total-balance-cell text-light-bold">
          <div className="float-right">{formatMoney(props.availableAllowance)}</div>
        </Table.Summary.Cell>
      </Table.Summary.Row>
    </Table.Summary>
  )
}

export default CompanyTotalBalance
